import {KitchenService} from '../KitchenService';
import {TAspectData} from '../../../../../common-code/types/TAspectData';
import {TKitchenImages} from '../../../../../common-code/types/TKitchenImages';
import {TKitchenSizesType} from '../../../../../common-code/types/project/TKitchenSizesType';
import {TWizardUIOptions} from '../../../../types/TWizardUIOptions';
import {CommonHelper} from 'common-code';
import {TKitchenCuttingImages} from '../../../types/TKitchenCuttingImages';
import {IDetailCuttingData} from '../../../interfaces/cutting/IDetailCuttingData';
import {RENDERER_TYPE_CUTTING, RENDERER_TYPE_DEFAULT} from '../../../constants';
import {BufferGeometry, Line, LineBasicMaterial, Mesh, Vector2} from 'three';
import {TLine} from '../../../../../common-code/types/TLine';
import {
    KITCHEN_SIZES_TYPE_ALL,
    KITCHEN_SIZES_TYPE_NONE, KITCHEN_VIEW_SKETCH,
    KITCHEN_VIEW_VISUAL
} from "../../../../../common-code/constants";
import {TImageScreenSettings} from "../../../../../common-code/types/project/TImageScreenSettings";
import {TKitchenImageSet} from "../../../../../common-code/types/project/TKitchenImageSet";
import {TKitchenView} from "../../../../../common-code/types/project/TKitchenView";

export class DrawManager {
    service: KitchenService;

    creatingImages: boolean;
    creatingCuttingImages: boolean;
    constructor(service: KitchenService) {
        this.service = service;
        this.creatingImages = false;
        this.creatingCuttingImages = false;
    }

    public async createImages(screenSettings: TImageScreenSettings): Promise<TKitchenImageSet | undefined> {
        if (!this.service.isReady()) {
            this.creatingImages = false;
            return undefined;
        }
        let oldOptions: TWizardUIOptions | undefined;

        if (!this.creatingImages) {
            oldOptions = CommonHelper.deepCopy(this.service.getOptions());
        }
        this.creatingImages = true;
        this.service.clearSelectCovers();
        const aspect: TAspectData | undefined = screenSettings.target && screenSettings.camera ?
            {camera: screenSettings.camera, target: screenSettings.target} : undefined;
        const visualImage: string = (!screenSettings.viewType || screenSettings.viewType === KITCHEN_VIEW_VISUAL) ?
            await this.createCanvasImage(KITCHEN_VIEW_VISUAL, screenSettings.sizesType || KITCHEN_SIZES_TYPE_NONE, aspect) : '';
        const sketchImage: string = (!screenSettings.viewType || screenSettings.viewType === KITCHEN_VIEW_SKETCH) ?
            await this.createCanvasImage(KITCHEN_VIEW_SKETCH, screenSettings.sizesType || KITCHEN_SIZES_TYPE_ALL, aspect) : '';
        this.creatingImages = false;
        if (oldOptions) {
            this.service.setViewType(oldOptions.viewType);
            this.service.setSizeType(oldOptions.sizesType);
        }

        return (visualImage.length || sketchImage.length) ? {
            visual: visualImage,
            sketch: sketchImage,
        } : undefined;
    }

    public createCanvasImage(
        viewType: TKitchenView,
        sizeType: TKitchenSizesType,
        aspect?: TAspectData
    ): Promise<string>  {
        return new Promise<string>((resolve, reject) => {
            if (!aspect) {
                aspect = this.service.getDefaultAspect();
            }
            this.service.clearSelectCovers();
            const oldViewType: TKitchenView = this.service.getViwType();
            const oldAspect: TAspectData | undefined = this.service.getCurrentAspect();
            const oldSizeType: TKitchenSizesType = this.service.getSizeType();
            this.service.setViewType(viewType);
            this.service.setSizeType(sizeType);
            this.service.renderStep();
            this.service.setAspect(aspect);
            this.service.renderStep();
            this.service.renderStep();
            this.createImage(RENDERER_TYPE_DEFAULT).then((imageData) => {
                resolve(imageData);
                this.service.setViewType(oldViewType);
                this.service.setSizeType(oldSizeType);
                if (oldAspect) {
                    this.service.setAspect(oldAspect);
                }
            }).catch(() => {
                reject();
            });
        })
    }

    public createDivImages(sizeType?: TKitchenSizesType, aspect?: TAspectData): Promise<TKitchenImages | undefined> {
        return new Promise<TKitchenImages | undefined>((resolve, reject) => {
            if (!this.service.isReady()) {
                this.creatingImages = false;
                resolve(undefined);
            }
            let oldOptions: TWizardUIOptions | undefined;

            if (!this.creatingImages) {
                oldOptions = CommonHelper.deepCopy(this.service.getOptions());
            }
            this.creatingImages = true;
            this.service.clearSelectCovers();
            this.service.setAspect(this.service.getDefaultAspect());
            this.service.renderStep();
            this.service.renderStep();
            this.createVisualImage(sizeType).then((visualImage) => {
                this.createDivSketchImage(sizeType,aspect).then((sketchImage) => {
                    this.creatingImages = false;
                    if (oldOptions) {
                        this.service.setViewType(oldOptions.viewType);
                        this.service.setSizeType(oldOptions.sizesType);
                    }
                    resolve({visual: visualImage, sketch: sketchImage, extraImages: []});
                })
            }).catch(() => {
                this.creatingImages = false;
                reject();
            });
        })
    }

    public createImagesEDIT(leftAspect: TAspectData, frontAspect: TAspectData): Promise<TKitchenImages | undefined> {
        return new Promise<TKitchenImages | undefined>((resolve, reject) => {
            if (!this.service.isReady()) {
                this.creatingImages = false;
                resolve(undefined);
            }
            let oldOptions: TWizardUIOptions | undefined;

            if (!this.creatingImages) {
                oldOptions = CommonHelper.deepCopy(this.service.getOptions());
            }
            this.creatingImages = true;
            this.service.clearSelectCovers();
            // this.service.setAspect(aspect);
            this.service.renderStep();
            this.service.renderStep();
            this.createVisualImage('none', leftAspect).then((visualImage_left) => {
                this.createVisualImage('none',frontAspect).then((visualImage_right) => {
                    this.createSketchImage('all',leftAspect).then((sketchImage) => {
                        this.creatingImages = false;
                        
                        if (oldOptions) {
                            this.service.setViewType(oldOptions.viewType);
                            this.service.setSizeType(oldOptions.sizesType);
                        }
                        resolve({visual: visualImage_right, sketch: sketchImage, extraImages: [], otherImages:[visualImage_left]});
                    })
                })  
            }).catch(() => {
                this.creatingImages = false;
                reject();
            });
        })
    }

    public createCuttingImages(): Promise<TKitchenCuttingImages | undefined> {
        return new Promise<TKitchenCuttingImages | undefined>((resolve, reject) => {
            if (!this.service.isReady()) {
                this.creatingCuttingImages = false;
                resolve(undefined);
            }
            let tabletopsCutting: IDetailCuttingData[];
            let apronsCutting: IDetailCuttingData[];

            this.creatingCuttingImages = true;
            this.service.initEditorCuttingViewer();
            tabletopsCutting = this.service.getDetailCuttingData(this.service.getTabletops());
            apronsCutting = this.service.getDetailCuttingData(this.service.getAprons());
            this.createCuttingImage(tabletopsCutting).then(tabletopImage => {
                this.createCuttingImage(apronsCutting).then(apronImage => {
                    this.creatingCuttingImages = false;
                    this.service.removeEditorCuttingViewer();
                    resolve({
                        tabletop: {
                            cuttingData: tabletopsCutting,
                            image: tabletopImage,
                        },
                        apron: {
                            cuttingData: apronsCutting,
                            image: apronImage,
                        }
                    });
                })
            }).catch(() => {
                this.creatingCuttingImages = false;
                this.service.removeEditorCuttingViewer();
                reject();
            });
        })
    }

    public createCuttingImage(cuttingData: IDetailCuttingData[]): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            let data: IDetailCuttingData;
            let lineMaterial: LineBasicMaterial;
            let line: Line;
            let textMesh: Mesh;

            this.service.clearEditorCuttingScene();
            lineMaterial = new LineBasicMaterial({color: '#000000', linewidth: 3});
            for (data of cuttingData) {
                line = new Line(new BufferGeometry().setFromPoints(data.points), lineMaterial);
                line.position.set(data.position.x, data.position.y, data.position.z);
                line.rotation.set(data.rotation.x, data.rotation.y, data.rotation.z);
                textMesh = this.service.createTextSizeMesh('' + data.index);
                textMesh.rotation.copy(line.rotation);
                textMesh.position.setY(-50);
                line.add(textMesh);
                this.addRedLines(data.redLines, line);
                this.service.addToCuttingSceneObject3D(line);
            }
            this.service.renderCuttingStep(cuttingData);
            this.createImage(RENDERER_TYPE_CUTTING, true).then((imageData) => {
                this.service.clearEditorCuttingScene();
                resolve(imageData);
            }).catch(() => {
                reject();
            });
        })
    }

    public createVisualImage(sizeType?: TKitchenSizesType, aspect?: TAspectData): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (!sizeType) {
                sizeType = KITCHEN_SIZES_TYPE_NONE;
            }
            if (!aspect) {
                aspect = this.service.getDefaultAspect();
            }
            this.service.clearSelectCovers();
            this.service.setViewType(KITCHEN_VIEW_VISUAL);
            this.service.setSizeType(sizeType);
            this.service.renderStep();
            this.service.setAspect(aspect);
            this.service.renderStep();
            this.service.renderStep();
            this.createImage('visual').then((imageData) => {
                resolve(imageData);
            }).catch(() => {
                reject();
            });
        })
    }

    public createSketchImage(sizeType?: TKitchenSizesType, aspect?: TAspectData): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (!sizeType) {
                sizeType = KITCHEN_SIZES_TYPE_ALL;
            }
            if (!aspect) {
                aspect = this.service.getDefaultAspect();
            }
            this.service.setViewType(KITCHEN_VIEW_SKETCH);
            this.service.setSizeType(sizeType);
            this.service.setAspect(aspect);
            this.service.renderStep();
            this.service.renderStep();
            this.createImage('sketch').then((imageData) => {
                resolve(imageData);
            }).catch(() => {
                reject();
            });
        })

    }

    public createDivSketchImage(sizeType?: TKitchenSizesType, aspect?: TAspectData): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (!sizeType) {
                sizeType = KITCHEN_SIZES_TYPE_ALL;
            }
            if (!aspect) {
                aspect = this.service.getDefaultAspect();
            }
            this.service.setViewType(KITCHEN_VIEW_SKETCH);
            this.service.setSizeType(sizeType);
            this.service.setAspect(aspect);
            this.service.renderStep();
            this.service.renderStep();
            this.createDivImage('sketch').then((imageData) => {
                resolve(imageData);
            }).catch(() => {
                reject();
            });
        })

    }

    protected createImage(rendererType: string, screenAll?: boolean): Promise<string> {
        return this.service.getImageData(rendererType, screenAll);
    }

    protected createDivImage(rendererType: string, screenAll?: boolean): Promise<string> {
        return this.service.getDivImageData(rendererType, screenAll);
    }

    protected addRedLines(redLines: TLine[], lineMesh: Line) {
        if (!redLines || !redLines.length) {
            return;
        }
        let redLine: TLine;
        const lineMaterial: LineBasicMaterial = new LineBasicMaterial({
            color: '#ff0000',
            linewidth: 3
        })

        for (redLine of redLines) {
            lineMesh.add(new Line(new BufferGeometry().setFromPoints([
                new Vector2(redLine.pointA.x, redLine.pointA.y),
                new Vector2(redLine.pointB.x, redLine.pointB.y)
            ]), lineMaterial))
        }
    }
}